<script>
  import {getContext} from 'svelte';
  import {lang$} from '@/store/lang';
  import {bannerList$} from '../streams';
  import Promotion from './Promotion.svelte';
  import WhoTrust from './WhoTrust.svelte';
  import WhoUse from './WhoUse.svelte';
  import lang from '../HomePage.lang';

  const LG = getContext('LG');

  const contents = [LG(lang.YouGonnaHearAndSee), LG(lang.ItsBeenPleasureSupport), LG(lang.ItsBeenPleasureWorkWith)];

  const users = {
    en: [
      {img: 'USE_EN1', name: 'Cantering Clark', subscribers: '154k'},
      {img: 'USE_EN2', name: 'Rager', subscribers: '204k'},
      {img: 'USE_EN3', name: 'Cold Blooded Shiller', subscribers: '189.7K'},
    ],
    es: [
      {img: 'USE_ES1', name: 'Tech Con Catalina', subscribers: '191K'},
      {img: 'USE_ES2', name: 'Monitor BTC', subscribers: '81K'},
      {
        img: 'USE_ES3',
        name: '@cryptokakarot1',
        subscribers: '28K',
      },
    ],
    tr: [
      {img: 'USE_TR1', name: 'Coin Muhendisi', subscribers: '232.7k'},
      {img: 'USE_TR2', name: 'Tuna Kaya ', subscribers: '286K'},
      {img: 'USE_TR3', name: 'Karasu', subscribers: '103k'},
    ],
    vi: [
      {img: 'USE_VI1', name: 'FOMOnista Trading Community', subscribers: '100k'},
      {img: 'USE_VI2', name: 'Sói Crypto', subscribers: '42,2k'},
      {img: 'USE_VI3', name: 'F.A Capital', subscribers: '12k'},
    ],
  };

  $: data = updateData($lang$);

  function updateData(curLang) {
    const userContent = genUsers(curLang);
    return [
      {
        label: LG(lang.WhoTrust),
        cards: [
          {
            title: LG(lang.Media),
            desc: LG(lang.Recognize),
            class: 'first',
            imgs: [
              {img: 'Forbes', alt: 'forbes'},
              {img: 'IBT', alt: 'IBT'},
              {img: 'NYP', alt: 'new york post'},
              {img: 'Forbes', alt: 'forbes'},
              {img: 'IBT', alt: 'IBT'},
              {img: 'NYP', alt: 'new york post'},
            ],
          },
          {
            title: LG(lang.License),
            desc: LG(lang.Certified),
            imgs: [
              {img: 'CZECH', alt: 'CZECH'},
              {img: 'POLAND', alt: 'POLAND'},
            ],
          },
          {
            title: LG(lang.Academic),
            desc: LG(lang.Partnered),
            imgs: [{img: 'PSL', alt: 'dauphine university'}],
          },
        ],
        component: WhoTrust,
      },
      {
        label: LG(lang.WhoUsePhemex),
        cards: userContent.map((item, i) => Object.assign({content: contents[i]}, item)),
        component: WhoUse,
      },
    ];
  }

  function genUsers(lang) {
    return users[lang] || users.en;
  }
</script>

<style>
  .outer {
    padding-bottom: 16px;
  }
  .wrap {
    margin: 0 auto;
    width: 1200px;
  }
  .caption {
    margin-top: 0;
    margin-bottom: 36px;
    font-family: gilroy-bold;
  }
  .wrap.recommend :global(.dots .dot) {
    width: 24px;
  }
  :global(.cards > .card) {
    border: 1px solid #454952;
    background: transparent !important;
  }
  @media screen and (max-width: 640px) {
    .outer {
      margin-top: 12px;
      padding: 0 0 12px;
    }
    .wrap {
      width: auto;
    }
    .caption {
      margin-bottom: 20px;
      padding: 0;
      font-size: 18px;
    }
    .cards {
      display: block;
    }
    :global(.wrap .slides .card) {
      padding: 0 16px;
    }
    :global(.cards > .card) {
      padding: 16px !important;
    }
  }
</style>

<section class="outer ovh">
  <Promotion />
</section>
